<template>
  <div class="root">
    <div class="containerPage">
      <img class="logo" alt="Just Logo" src="@/assets/images/logo_just.png" />
      <router-view />
      </div>
      <footer class="footer">
        <div class="footer-content">
          <a target="_blank" href="https://www.facebook.com/JustArgentinaOficial/" >
            <img src="@/assets/images/facebook.svg" alt="Just en facebook" />
          </a>
          <a target="_blank" href="https://www.instagram.com/just.arg/">
            <img src="@/assets/images/instagram.svg" alt="Just en instagram" />
          </a>
          <a target="_blank" href="https://www.youtube.com/user/SwissJustArgentina1" >
            <img src="@/assets/images/youtube.svg" alt="Just en youtube" />
          </a>
          <a target="_blank" href="https://www.flickr.com/photos/swissjustargentina2012/">
            <img src="@/assets/images/flickr.svg" alt="Just en facebook"/>
          </a>
        </div>
      </footer>
  </div>
</template>

<script>

import { onMounted } from '@vue/runtime-core';

export default {
  components: {
  },
  setup() {
    onMounted(async () => {
      
    });

    return{
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/main.scss';
</style>
